import { Theme } from '@pga/pga-component-library'
import { prop } from 'ramda'
import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import MediaQuery from 'react-responsive'
import { withAuthProvider } from '../../../lib/auth'

import ComponentFilterItem from './ComponentFilterItem'
import FilterHeader from './FilterHeader'
import RefinementFilterItem from './RefinementFilterItem'
import filterConfig from './filterConfig'
import { ModalTrigger, SideBar } from './SearchModal'

const SearchFiltersContainer = styled.div`
  width: 270px;
  padding: 20px;

  .ais-RefinementList {
    text-align: left;
  }
  .ais-RefinementList-labelText {
    font-family: ${Theme.fonts.Montserrat};
    height: 24px;
    color: ${Theme.colors.primary};
    font-weight: normal;
    font-size: 12px;
    line-height: 24px;
  }
  .ais-RefinementList-count {
    display: none;
  }
  .ais-RefinementList-showMore {
    font-family: ${Theme.fonts.Montserrat};
    color: ${Theme.colors.lightBlue};
    background-color: transparent;
    padding: 0;
    outline: 0;
  }

  @media (max-width: 576px) {
    select.form-control {
      width: auto;
      margin-top: -10px;
    }
  }

  .ais-RefinementList-item {
  }
  /* Hide checkbox and replace with custom built with css*/
  .ais-RefinementList-checkbox {
    visibility: hidden;
  }

  .ais-RefinementList-labelText:before {
    content: '';
    margin-right: 10px;
    margin-left: -15px;
    display: inline-block;
    vertical-align: text-top;
    width: 20px;
    height: 20px;
    background: white;
    border: 1px solid ${Theme.colors.blueGrey};
    cursor: pointer;
  }
  .ais-RefinementList-checkbox:checked + .ais-RefinementList-labelText:before {
    background: white url("data:image/svg+xml;utf8,<svg viewBox='0 0 10 9' xmlns='http://www.w3.org/2000/svg'><path d='M1 4.88l2.378 2.435L9.046 1.6' stroke-width='1.6' stroke='%230082CE' fill='none' fill-rule='evenodd' stroke-linecap='round' stroke-linejoin='round'/></svg>")no-repeat 50%/10px;
  }
`
const FilterArea = styled.div`
  display: flex;
  background-color: ${props => props.theme.colors.white};
  box-shadow: 0 5px 10px 0 ${props => props.theme.primaryShadow};
  margin-bottom: 16px;
  width: 100%;
  height: 54px;

  @media (min-width: 768px) {
    margin-bottom: 32px;
  }

  @media (min-width: 992px) {
    flex: 0 0 270px;
    width: 270px;
    height: auto;
    margin-right: 32px;
  }
`
const isLoggedIn = ({ authReady, isLoggedIn }) => authReady && isLoggedIn
const ComponentFilterAuthCheck = (props) => {
  return props.requireLogin
    ? isLoggedIn(props) ? <ComponentFilterItem {...props} /> : null
    : <ComponentFilterItem {...props} />
}

const Filter = (props) => (item, idx) => {
  return prop('Component', item)
    ? <ComponentFilterAuthCheck key={idx} {...item} {...props} />
    : <RefinementFilterItem key={idx} {...item} />
}

const Filters = withAuthProvider((props) => (
  <SearchFiltersContainer>
    <FilterHeader {...props} />
    {filterConfig.map(Filter(props))}
  </SearchFiltersContainer>
))

const FiltersContainer = (props) => {
  const { toggle, toggledOn } = props
  return (
    <FilterArea>
      <MediaQuery maxWidth={991}>
        <ModalTrigger toggle={toggle} />
        <SideBar isOpen={toggledOn} toggle={toggle}>
          <Filters {...props} />
        </SideBar>
      </MediaQuery>
      <MediaQuery minWidth={992}>
        <Filters {...props} />
      </MediaQuery>
    </FilterArea>
  )
}

FiltersContainer.propTypes = {
  searchState: PropTypes.object.isRequired,
  onSearchStateChange: PropTypes.func.isRequired,
  toggle: PropTypes.func,
  toggledOn: PropTypes.bool
}

export default FiltersContainer
